import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: var(--gap-m);
`;

export const LabelRow = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 4px;
	gap: var(--gap-x2);
`;
